import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const PRODUCT_URL = `${API_BASE_URL}/product`;
const CART_URL = `${API_BASE_URL}/cart`;
const DELIVERY_URL = `${API_BASE_URL}/delivery`;
const USER_URL = `${API_BASE_URL}/users`;
const ORDERITEMS_URL = `${API_BASE_URL}/order-item`;
const ORDER_URL = `${API_BASE_URL}/orders`;
const PAYMENT_URL = `${API_BASE_URL}/payment`;
const WISHLIST_URL = `${API_BASE_URL}/wishlists`;
const AFFILIATE_URL = `${API_BASE_URL}/affiliates`;
const BECOMEVENDOR_URL = `${API_BASE_URL}/vendor`;

// Helper function to add authorization headers
// const addAuthHeader = (config) => {
//   const token = localStorage.getItem("authToken");
//   if (token) {
//     config.headers.Authorization = `Bearer ${token}`;
//   }
//   return config;
// };

const PRODUCTHTTP = axios.create({
  baseURL: PRODUCT_URL,
});

PRODUCTHTTP.interceptors.request.use(function (config) {
  const token = localStorage.getItem("authToken");
  config.headers.Authorization = `Bearer ${token}`;

  return config;
});

const CARTHTTP = axios.create({
  baseURL: CART_URL,
});
CARTHTTP.interceptors.request.use(function (config) {
  const token = localStorage.getItem("authToken");
  config.headers.Authorization = `Bearer ${token}`;

  return config;
});

const DELIVERYHTTP = axios.create({
  baseURL: DELIVERY_URL,
});
DELIVERYHTTP.interceptors.request.use(function (config) {
  const token = localStorage.getItem("authToken");
  config.headers.Authorization = `Bearer ${token}`;

  return config;
});

const USERHTTP = axios.create({
  baseURL: USER_URL,
});
USERHTTP.interceptors.request.use(function (config) {
  const token = localStorage.getItem("authToken");
  config.headers.Authorization = `Bearer ${token}`;

  return config;
});

const ORDERITEMSHTTP = axios.create({
  baseURL: ORDERITEMS_URL,
});
ORDERITEMSHTTP.interceptors.request.use(function (config) {
  const token = localStorage.getItem("authToken");
  config.headers.Authorization = `Bearer ${token}`;

  return config;
});

const ORDERHTTP = axios.create({
  baseURL: ORDER_URL,
});
ORDERHTTP.interceptors.request.use(function (config) {
  const token = localStorage.getItem("authToken");
  config.headers.Authorization = `Bearer ${token}`;

  return config;
});

const PAYMENTHTTP = axios.create({
  baseURL: PAYMENT_URL,
});
PAYMENTHTTP.interceptors.request.use(function (config) {
  const token = localStorage.getItem("authToken");
  config.headers.Authorization = `Bearer ${token}`;

  return config;
});

const WISHLISTHTTP = axios.create({
  baseURL: WISHLIST_URL,
});
WISHLISTHTTP.interceptors.request.use(function (config) {
  const token = localStorage.getItem("authToken");
  config.headers.Authorization = `Bearer ${token}`;

  return config;
});

const AFFILIATEHTTP = axios.create({
  baseURL: AFFILIATE_URL,
});
AFFILIATEHTTP.interceptors.request.use(function (config) {
  const token = localStorage.getItem("authToken");
  config.headers.Authorization = `Bearer ${token}`;

  return config;
});

const REGISTERVENDORHTTP = axios.create({
  baseURL: BECOMEVENDOR_URL,
});
REGISTERVENDORHTTP.interceptors.request.use(function (config) {
  const token = localStorage.getItem("authToken");
  config.headers.Authorization = `Bearer ${token}`;

  return config;
});

// [PRODUCTHTTP, CARTHTTP, DELIVERYHTTP, USERHTTP, ORDERITEMSHTTP].forEach(
//   (instance) => {
//     instance.interceptors.request.use(addAuthHeader, (error) =>
//       Promise.reject(error)
//     );
//   }
// );

const exportAPIs = {
  PRODUCTHTTP,
  CARTHTTP,
  DELIVERYHTTP,
  USERHTTP,
  ORDERITEMSHTTP,
  ORDERHTTP,
  PAYMENTHTTP,
  WISHLISTHTTP,
  AFFILIATEHTTP,
  REGISTERVENDORHTTP,
};
export default exportAPIs;
